import type { FaireProductEntity } from "../../entity_types/product";

export const p_p6gtupb5bz: FaireProductEntity = {
  token: "p_p6gtupb5bz",
  type: "product",
  name: "Taylor Is My Therapist Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/0a4423d2c3ae86bab1f06cbbfcb2739169c92b4d32e4be264c7f3acf73cda6c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/597be16330f4d31891d3e1560451973f587475e3744638dcc8de0b75551c62d0.jpeg",
    "https://cdn.faire.com/fastly/16a6ceb359cf9af2ad496189ecd1529ab0c7a7305e909be43c49bba1a58cf05f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/b6bb5df27fd63fa8504411de6e0e9df9ea8e06d1724710cfde2dd6c467f0b461.jpeg",
    "https://cdn.faire.com/fastly/1cf6e3a79d118bab280e5cb32980c76e380c0e4da3a1db034e5d13b3f24760d5.jpeg"
  ],
  priceDollars: 6.75,
  description: "There's no better way to swiftly process your feelings than to throw on some comfy socks and spend some quality time with Taylor. 💗\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:56.368Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
